import React from 'react';
export const CitrusSlice = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-24">
    <circle cx="50" cy="50" r="48" fill="currentColor" data-id="element-25" />
    <circle cx="50" cy="50" r="42" fill="white" fillOpacity="0.2" data-id="element-26" />
    <path d="M50 50L50 10A40 40 0 0 1 84.6 30L50 50Z" fill="white" fillOpacity="0.4" data-id="element-27" />
    <path d="M50 50L84.6 30A40 40 0 0 1 84.6 70L50 50Z" fill="white" fillOpacity="0.4" data-id="element-28" />
    <path d="M50 50L84.6 70A40 40 0 0 1 50 90L50 50Z" fill="white" fillOpacity="0.4" data-id="element-29" />
    <path d="M50 50L50 90A40 40 0 0 1 15.4 70L50 50Z" fill="white" fillOpacity="0.4" data-id="element-30" />
    <path d="M50 50L15.4 70A40 40 0 0 1 15.4 30L50 50Z" fill="white" fillOpacity="0.4" data-id="element-31" />
    <path d="M50 50L15.4 30A40 40 0 0 1 50 10L50 50Z" fill="white" fillOpacity="0.4" data-id="element-32" />
  </svg>;
export const Sun = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-33">
    <circle cx="50" cy="50" r="30" fill="currentColor" data-id="element-34" />
    <path d="M50 5L50 15M50 85L50 95M81.8 18.2L74.7 25.3M25.3 74.7L18.2 81.8M95 50L85 50M15 50L5 50M81.8 81.8L74.7 74.7M25.3 25.3L18.2 18.2" stroke="currentColor" strokeWidth="6" strokeLinecap="round" data-id="element-35" />
  </svg>;
export const PalmLeaf = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-36">
    <path d="M10 90C10 90 30 50 80 10C80 10 70 30 90 40C90 40 70 45 85 60C85 60 60 55 70 75C70 75 50 65 50 85C50 85 30 70 10 90Z" fill="currentColor" data-id="element-37" />
  </svg>;
export const Wave = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 100 20" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-38">
    <path d="M0 10C25 10 25 0 50 0C75 0 75 10 100 10V20H0V10Z" fill="currentColor" data-id="element-39" />
  </svg>;